(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/promos/views/no-open-draws.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/promos/views/no-open-draws.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.promos.views.NoOpenDraws = Backbone.Marionette.View.extend({
    className: 'match-promo-no-open-draws align-center',
    template: function(data) {
      return svs.app.product_start_page.templates.no_open_draws(data);
    },
    initialize: function() {
      this.model = new Backbone.Model(this.options);
    }
  });
})(Backbone, _, svs);

 })(window);